import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import {
  fetchTagsAndSegmentsError,
  fetchTagsAndSegmentsSuccess,
  getLanguagesError,
  getLanguagesSuccess,
  updateLanguagesError,
  updateLanguagesSuccess,
} from './actions'
import {
  LANGUAGES_REQUEST_ASYNC,
  TAGS_AND_SEGMENTS_REQUEST_ASYNC,
  UPDATE_LANGUAGES_ASYNC,
} from './constants'
import { selectLanguages, selectSaveLanguageFromTags, selectTagsAndSegments } from './selectors'

const getLanguagesSettingsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS, LANGUAGES_REQUEST_ASYNC.INITIATE)
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.languages)
      return true
    })
    .mergeMap(() =>
      api.settings
        .getLanguages(store.getState().partnerOptions.selectedCompany?.value, true)
        .map((response) => getLanguagesSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(getLanguagesError, error)))
        .takeUntil(action$.ofType(LANGUAGES_REQUEST_ASYNC.CANCEL))
    )

const updateLanguagesSettingsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(UPDATE_LANGUAGES_ASYNC.INITIATE).mergeMap(() => {
    const state = store.getState()
    const companyId = state.partnerOptions.selectedCompany?.value
    const languages = selectLanguages(state)
    const defaultLanguage = languages.find((language) => language.default).id
    const saveLanguageFromTags = selectSaveLanguageFromTags(state)
    const selectedLanguages = languages
      .filter((language) => language.enabled)
      .map((language) => language.id)
    const associatedLanguages = languages
      .filter((language) => language.associate)
      .map((language) => ({
        langId: language.id,
        attrType: language.associate.tag !== undefined ? 'tag' : 'segment',
        attrId: language.associate.tag || language.associate.segment,
      }))

    return api.settings
      .updateLanguages(companyId, {
        defaultLanguage,
        saveLanguageFromTags,
        selectedLanguages,
        associatedLanguages,
      })
      .map((response) => updateLanguagesSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(updateLanguagesError, error)))
      .takeUntil(action$.ofType(UPDATE_LANGUAGES_ASYNC.CANCEL))
  })

const fetchTagsAndSegmentsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS, TAGS_AND_SEGMENTS_REQUEST_ASYNC.INITIATE)
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.languages)
      return true
    })
    .mergeMap(() =>
      api.mailboxes
        .getTagsAndSegments({
          companyId: store.getState().partnerOptions.selectedCompany?.value,
          page: selectTagsAndSegments(store.getState()).page,
          search: selectTagsAndSegments(store.getState()).search,
        })
        .map((response) => fetchTagsAndSegmentsSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchTagsAndSegmentsError, error)))
        .takeUntil(action$.ofType(TAGS_AND_SEGMENTS_REQUEST_ASYNC.CANCEL))
    )

export default combineEpics(
  getLanguagesSettingsEpic,
  updateLanguagesSettingsEpic,
  fetchTagsAndSegmentsEpic
)
